import React, { useCallback, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import bookSelectors from 'store/selectors/booking'
import snackbarActions from 'store/modules/snackbar'

import FormContext from './FormContext'
import FormWrapper from 'components/form/Wrapper'
import Render from 'components/form/Render'
import SummaryWrapper from './SummaryWrapper'

const FormPageRender = ({
  schema,
  isValid,
  values,
  errors,
  withAlert,
  showErrors,
  touched,
  withStoreOptions,
  onBack,
  onSubmit,
}) => {

  const dispatch = useDispatch()
  const formConfig = useSelector(bookSelectors.slotFormConfig)

  const onSubmitWrapper = useCallback(() => {
    if(!isValid) {
      dispatch(snackbarActions.setError('There are errors in the form, please correct before proceeding'))
    }
    onSubmit()
  }, [
    onSubmit,
    isValid,
  ])

  if(!formConfig) return null

  return (
    <SummaryWrapper
      values={ values }
      errors={ errors }
      withAlert={ withAlert }
      showErrors={ showErrors }
      withStoreOptions={ withStoreOptions }
      onBack={ onBack }
      onSubmit={ onSubmitWrapper }
    >
      <Render
        fullHeight
        schema={ schema }
        isValid={ isValid }
        values={ values }
        errors={ errors }
        touched={ touched }
        showErrors={ false }
        onSubmit={ onSubmitWrapper }
      />
    </SummaryWrapper>
  )
}

const BookingFormPage = ({
  initialValues,
  schema,
  validate,
  withStoreOptions,
  withAlert,
  onBack,
  onSubmit,
}) => {

  const formDirectionRef = useRef('forward')

  return (
    <FormContext.Provider value={{
      direction: formDirectionRef.current,
      setDirection: (direction) => formDirectionRef.current = direction,
    }}>
      <FormWrapper
        schema={ schema }
        initialValues={ initialValues }
        handlers={{
          validate,
        }}
        onSubmit={ (payload) => {
          onSubmit(payload, formDirectionRef.current)
        }}
      >
        {
          ({
            isValid,
            values,
            errors,
            showErrors,
            touched,
            onSubmit,
          }) => {
            return (
              <FormPageRender
                schema={ schema }
                isValid={ isValid }
                withAlert={ withAlert }
                values={ values }
                errors={ errors }
                showErrors={ showErrors }
                touched={ touched }
                withStoreOptions={ withStoreOptions }
                onBack={ onBack }
                onSubmit={ onSubmit } 
              />
            )
          }
        }  
      </FormWrapper>
    </FormContext.Provider>
  )
}

export default BookingFormPage